
import {defineComponent, onMounted, reactive, ref} from "vue";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import DateTime from "@/components/common/DateTime.vue";

export default defineComponent({
  name: "customers-listing",
  components: {DateTime},
  setup() {
    const tableData = ref([]);

    onMounted(() => {
      setCurrentPageBreadcrumbs("Clientes", []);
      load()
    });

    const search = ref<string>("");
    let searching;
    const searchItems = (): void => {
      clearTimeout(searching)
      searching = setTimeout(() => load(), 700)
    };

    const load = (): void => {
      ApiService.setHeader();
      ApiService.get(`v1/backend/users?page=${pagination.page}&email=${search.value}`)
          .then(({data}) => {
            tableData.value = data.data;
            pagination.page = data.current_page;
            pagination.total = data.total;
          })
          .catch(({response}) => {
            console.log(response);
          });
    };

    const pagination = reactive({
      page: 1,
      total: 0,
    })

    return {
      tableData,
      search,
      load,
      pagination,
      searchItems,
    };
  },
});
